import { render, staticRenderFns } from "./ArticleStock.vue?vue&type=template&id=9c5e645e&scoped=true&"
import script from "./ArticleStock.vue?vue&type=script&lang=js&"
export * from "./ArticleStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5e645e",
  null
  
)

export default component.exports